import { useRef, useEffect, useState } from "react";
import ReactDOM from 'react-dom';

//import "../../public/";
const AutoComplete = (props) => {
  const autoCompleteRef = useRef();
  const inputRef = useRef();
  const [address, setAddress] = useState('');
  const [streetAddress, setStreetAddress] = useState('');
  const [streetAddress2, setStreetAddress2] = useState('');
  const [city, setCity] = useState('');
  const [state, setState] = useState('');
  const [postalCode, setPostalCode] = useState('');
  const [county, setCounty] = useState('');
  const [country, setCountry] = useState('');
  const [defaultValue, setDefaultValue] = useState('');
  const autocomplete = useRef(null);
  const options = {
    //componentRestrictions: {  },
    fields: ["address_components", "geometry", "icon", "name"],
    types: []
  };
  useEffect(() => {
    const init = () => {
      //@ts-ignore
      if (!window.google?.maps?.places) return;
      //@ts-ignore
      autoCompleteRef.current = new window.google.maps.places.Autocomplete(
        inputRef.current,
        options
      );
      initAutocomplete();
    };

    //@ts-ignore
    if (window.google?.maps?.places) {
      init();
    } else {
      // Wait for Google Maps script to load
      const interval = setInterval(() => {
        //@ts-ignore
        if (window.google?.maps?.places) {
          clearInterval(interval);
          init();
        }
      }, 100);
      return () => clearInterval(interval);
    }
  }, []);

  useEffect(() => {
    //This allows you to input a value prop to provide a default value for the field.
    if (props.value && !defaultValue) {
      setAddress(props.value)
      setDefaultValue(props.value)
    }

    if(props.value !== defaultValue){
      // this handles when the value prop changes and allows it to be an empty string when patient is selected
      setAddress(props.value)
    }
  }, [props.value])

  const initAutocomplete = () => {
    const input = document.getElementById(props.id);
    //@ts-ignore
    autocomplete.current = new window.google.maps.places.Autocomplete(input);
    autocomplete.current.addListener('place_changed', handlePlaceSelect);
  };

  const handlePlaceSelect = () => {
    const place = autocomplete.current.getPlace();
    if (!place || !place.address_components) {
      console.error("No place selected or address components missing");
      return;
    }

    // console.log("HIT PLACES", place)
    const addressComponents = place.address_components;
    let streetAddress = '';
    let streetAddress2 = '';
    let city = '';
    let state = '';
    let postalCode = '';
    let country = '';
    let county = '';

    // Process and use the address components as needed
    for (const component of addressComponents) {
      for (const componentType of component.types) {
        switch (componentType) {
          case 'street_number':
            streetAddress = component.long_name; // Set street number
            break;
          case 'subpremise':
          case 'sublocality':
            streetAddress2 = component.long_name;
            break;
          case 'route':
            streetAddress = streetAddress + ' ' + component.long_name;
            break;
          case 'locality':
            city = component.long_name;
            break;
          case 'administrative_area_level_1':
            //short_name for abbreviated state names
            state = component.short_name;
            break;
          case 'administrative_area_level_2':
            // Cleveland County should be saved as Cleveland
            county = component.long_name;
            if (county.includes(' County')) {
              county = county.replace(' County', '');
            }
            break;
          case 'postal_code':
            postalCode = component.long_name;
            break;
          case 'country':
            country = component.long_name;
            break;
          default:
            break;
        }
      }
    }
    setStreetAddress(streetAddress);
    setStreetAddress2(streetAddress2);
    setCity(city);
    setState(state);
    setPostalCode(postalCode);
    setCounty(county);
    setCountry(country);
    setAddress(place.formatted_address);

    props.updateFormData(streetAddress, streetAddress2, city, state, postalCode, county, country)
  };

  const handleChange = (event) => {
    props.onChange(event.target.value)
    setAddress(event.target.value);
  };

  return (
    <input type="text" className="form-control" id={props.id} placeholder="123 Main Street..."
      ref={inputRef} value={address}
      onChange={(e) => { handleChange(e) }}
    />
  );
};
export default AutoComplete;